module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@3x-103e4f94a6982f504fe937cec28a1367.png";